module.exports = __webpack_public_path__ + "static/img/1.45bd214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente/1.jpg
// module id = gn60
// module chunks = 0